export const openIntercomChat = () => {
    // @ts-expect-error
    if (window.Intercom) {
        // @ts-expect-error
        window.Intercom("showNewMessage");
    } else {
        alert("Intercom Live Chat was blocked. Please allow the script (noscript or adblocker) and try again.");
    }
};
